var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAcuerdos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9892V12.6583L12.6583 0L14.4822 1.82383L12.1029 12.3199H28.4167V17.5822L21.7258 32.9866L0 32.9892ZM2.58333 30.4058H20.0415L25.8333 16.8795V14.9007H8.95383L11.098 5.24417L2.58333 13.733V30.4058ZM46.7583 59.4167L44.9345 57.5928L47.3163 47.0968H31V41.8345L37.6908 26.4301H59.4167V46.7583L46.7583 59.4167ZM48.3187 54.1725L56.8333 45.6863V29.0108H39.3752L33.5833 42.5372V44.5134H50.4654L48.3187 54.1725Z",
    fill: "#303376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAcuerdos);
export default __webpack_public_path__ + "static/media/ic_acuerdos.dfff42305c864badfe08f7ec15818f7a.svg";
export { ForwardRef as ReactComponent };